import React, { useRef } from "react";
import classNames from "classnames";


interface TextInputGroupProps {
    value?: string;
    defaultValue?: string;
    font?: string;
    label?: string;
    description?: string;
    placeholder?: string;
    invalid?: boolean;
    invalidText?: string;
    rowGap?: number;
    disabled?: boolean;
    onChange: (value: string) => void;
}

const TextInputGroup: React.FC<TextInputGroupProps> = (props) => {
    const {
        value,
        defaultValue,
        font,
        label,
        description,
        placeholder,
        invalid,
        invalidText,
        onChange,
        rowGap = 6,
        disabled
    } = props;

    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div className="flex flex-col" style={{ rowGap }}>
            {label&& (
                <div className={classNames("input-group-heading", font)}>
                    {label}
                </div>
            )}

            <div className="flex flex-col gap-1">
                <input type="text"
                       ref={inputRef}
                       disabled={disabled}
                       value={value}
                       defaultValue={defaultValue}
                       placeholder={placeholder}
                       className={classNames("input-default", invalid && "input-invalid")}
                       onChange={e => onChange(e.target.value)}
                />
                {description && (
                    <div className="font-[400] text-[12px] leading-[1.5] text-black-400">
                        {description}
                    </div>
                )}
                {invalidText && invalid && (
                    <span className="font-[400] text-[14px] leading-none text-point-red">
                        {invalidText}
                    </span>
                )}
            </div>
        </div>
    );
};

export default TextInputGroup;